import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {_empresa_sitemap} from "@components/empresas/endpoints/__empresa_endpoints.ts";
import {NavButton, NavButtonProps} from "@shared/custom/NavButton.tsx";
import {useEffect, useMemo, useState} from "react";
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";

interface EmpresaInfoNavLinkProps extends Omit<DefaultInfoV1Props<IEmpresa>, 'variant' | 'EndComponent'>, NavButtonProps<IEmpresa> {

}

export function EmpresaInfoNavButton(props: EmpresaInfoNavLinkProps) {
    const {empresas} = _empresa_sitemap
    const {displayMode} = props
    const {getEmpresa} = useEmpresa()

    const [value, setValue] = useState(props.value);

    useEffect(() => {
        if (value == null && props.expectedId) {
            getEmpresa({id: props.expectedId}).then(x => {
                    if (x.items != null) {
                        setValue(x.items)
                    }
                }
            )
        }
    }, [value])

    const navLinkProps: NavButtonProps<IEmpresa> = useMemo(() => {
        return {
            ...props,
            value: value,
            pathname: empresas.children?.['detalhes'].fullUrl,
            searchData: {empresaId: value?.id},
        }
    }, [value, empresas, displayMode])

    if (value == null) return null;


    return (<NavButton {...navLinkProps}/>)
}